import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SecondsDurationPipe } from './seconds-duration.pipe';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';

@Pipe({
  name: 'dateDiffFromNow'
})
export class DateDiffFromNowPipe implements PipeTransform {

  constructor(private translate: TranslateService, private secondsDurationPipe: SecondsDurationPipe) {
  }

  transform(date: moment.Moment, nbUnits = 1, onlyPastDate = false, hideSeconds: boolean = false): Observable<any> {
    if (!date) {
      return null;
    }

    const now  = moment();
    const diff = date.diff(now, 'seconds');

    if (diff === 0) {
      return this.translate.get('time.now');
    }

    if (onlyPastDate && diff <= 0) {
      return of('');
    }

    return this.secondsDurationPipe.transform(Math.abs(diff), nbUnits, hideSeconds)
      .pipe(
        flatMap(secondsDuration => this.translate.get(
          diff > 0 ? 'time.@in' : 'time.@ago',
          { duration: secondsDuration }
        ))
      );
  }

}
